import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getOverview      = (token)  => Axios.get("/api/v1/admin/blog/analytics/overview", h(token));
export const getPostAnalytics = (id, token) => Axios.get(`/api/v1/admin/blog/analytics/posts/${id}`, h(token));
